var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('elsa-tree',{attrs:{"accordion":"","icon-class":"tree-icon","data":_vm.treeData},on:{"assign":_vm.handleAssign},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var node = ref.node;
return [_c('span',{class:node.data.options.titleClassArray},[_vm._v(" "+_vm._s(_vm.getTitlel(node.data))+" ")])]}},{key:"subtitle",fn:function(ref){
var node = ref.node;
return [_c('span',{staticClass:"subtitle"},[_vm._v(_vm._s(node.data.textSubTitle))])]}},{key:"tags",fn:function(ref){
var node = ref.node;
return [(node.data.cefr_level)?_c('span',{staticClass:"tag"},[_vm._v(_vm._s(node.data.cefr_level))]):_vm._e()]}},{key:"customContent",fn:function(ref){
var node = ref.node;
return [_c('detail-goals-all',{attrs:{"data":node.data,"orgType":_vm.currentOrganizationType}})]}}])}),_c('add-assignment-wrapper',{ref:"addAssignment"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }